module.exports = __webpack_public_path__ + "img/logo.2e33506f.jpg";